import { VALUE_TYPE } from "Components/NumberValue";
import { formatToLocaleString } from "./formatNumber";

export function formatInput(input: string, regex: RegExp): string {
  if (regex.test(input)) {
    const matches = input.match(regex);
    if (matches) {
      let formatted = "";
      matches.forEach((value, index) => {
        if (index > 0 && isValue(value)) {
          if (hasValueOrWhitespaceAfter(matches, index)) {
            formatted += `${value} `;
          } else {
            formatted += value;
          }
        }
      });
      return formatted;
    }
  }
  return "";
}

function hasValueOrWhitespaceAfter(
  matches: RegExpMatchArray,
  index: number,
): boolean {
  return (
    (matches.length > index + 2 && isValue(matches[index + 2])) ||
    (matches.length > index + 1 && isWhitespace(matches[index + 1]))
  );
}

function isValue(value?: string): boolean {
  if (!value) {
    return false;
  }
  return /\S/.test(value);
}

function isWhitespace(value?: string): boolean {
  if (!value) {
    return false;
  }
  return /\s/.test(value);
}

export function removeWhitespace(value: string): string {
  return value.replace(/\s+/g, "");
}

export function removeWhitespaceOptional(value?: string): string | undefined {
  return value?.replace(/\s+/g, "");
}

export function formatNumber(number: string, float: boolean): string {
  if (float) {
    number = removeAllNonDigitsFloat(number);
    number = formatFloatToNorwegianLocale(number);
  } else {
    number = removeAllNonDigits(number);
    number = formatIntegerToNorwegianLocale(number);
  }
  return number;
}

export function removeAllNonDigits(value: string): string {
  return value.replace(/[^\d]+/g, "");
}

export function removeAllNonDigitsFloat(value: string): string {
  return value.replace(/[^\d.,]+/g, "");
}

export function formatIntegerToNorwegianLocale(sum: string): string {
  const regex = /\B(?=(\d{3})+(?!\d))/g;
  const cleanedSum = removeWhitespace(sum);
  if (regex.test(cleanedSum)) {
    return cleanedSum.replace(regex, " ");
  }
  return sum;
}

export function formatFloatToNorwegianLocale(sum: string): string {
  return sum
    .toString()
    .split(/[\.\,]/g)
    .map((value, index) => {
      if (index === 0) {
        return formatIntegerToNorwegianLocale(value);
      }
      return value;
    })
    .join(",");
}

export function formatNumberStringToNumber(numberAsString?: string): number {
  if (!numberAsString) {
    return 0;
  }
  const cleanedNumber = removeWhitespace(numberAsString);

  return cleanedNumber ? parseInt(cleanedNumber) : 0;
}

export function extractOnlyNumbersFromString(
  dirtyNumberString?: string,
): number {
  if (!dirtyNumberString) {
    return 0;
  }

  return parseInt(dirtyNumberString.replace(/\D/g, ""));
}

export const formatNumberStringToNearestThousandNumber = (
  value: string,
): number => {
  const valueAsNumber = formatNumberStringToNumber(value);
  return Math.round(valueAsNumber / 1000) * 1000;
};

export const getPriceFormatFromValue = (
  value: string | number | undefined,
  type: VALUE_TYPE,
): string => {
  if (value === undefined) {
    return "";
  }
  return typeof value === "string"
    ? `${formatToLocaleString(parseInt(value))}${"\u2009"}${type}`
    : `${formatToLocaleString(value)}${"\u2009"}${type}`;
};
